import { chaikinVolSeries, numericExtent } from "../utils";
const CHAIKINVOL = {
    name: "ChaikinVol",
    compute: (bars, period = 10) => chaikinVolSeries(bars, period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default CHAIKINVOL;
